<template>
  <v-chip
    v-if="status"
    small
    :color="color"
    dark
  >
    {{ text }}
  </v-chip>
</template>

<script>
export default {
  props: {
    status: String,
  },

  computed: {
    text() {
      return {
          'on-hold': this.$t('暫存'),
          'submitted': this.$t('已送件'),
          'in-progress': this.$t('已送件'),
          'pending-provision': this.$t('預計開通'),
          'pending-review': this.$t('已開通'),
          'provisioned': this.$t('已開通'),
          'returned':  this.$t('已開通'),
          'rejected': this.$t('已退卡'),
          'suspended': this.$t('已開通'),
          'has-issue': this.$t('問題件'),
        }[this.status];
    },

    color() {
      return {
        'on-hold': 'orange',
        'submitted': 'info',
        'in-progress': 'info',
        'pending-provision': 'info',
        'pending-review': 'green',
        'provisioned': 'green',
        'returned': 'green',
        'rejected': 'grey',
        'suspended': 'warning',
        'has-issue': 'red',
      }[this.status];
    }
  },
}
</script>
